<template>
	<div class="info">
		<navbar></navbar>
		<section class="content">

			<md-card>
				<md-card-header>
					<div class="md-title">{{$t("peakflowmeter")}}</div>
				</md-card-header>
				<md-card-content>
					<p>
						{{$t("peakflowmeterinfo")}}</br></br>

						{{$t("peakflowmeterlink")}} <a href="http://www.webbeteg.hu/cikkek/asztma/289/hogyan-diagnosztizaljak-az-asztmat">http://www.webbeteg.hu/cikkek/asztma/289/hogyan-diagnosztizaljak-az-asztmat</a>
					</p>

					<iframe width="320" height="200" src="https://www.youtube.com/embed/2gwGmyBdq_o" frameborder="0" allowfullscreen></iframe>
				</md-card-content>
			</md-card>

		</section>
	</div>
</template>

<script>
	import Navbar from './Navbar'

	export default {
		components: {
			Navbar
		},
		mounted(){
		}
	}
</script>

<style scoped>
	.content{
		margin: 16px;
	}
</style>



// WEBPACK FOOTER //
// InfoView.vue?e3b0fab8